import { useNavigate } from "@solidjs/router";
import { createSignal, Show } from "solid-js";
import { isAdmin } from "../../store/admin";
import { api } from "../../store/api";
import { queryClient } from "../../store/query";
import { settingsQueryKey } from "./WebsiteSettings";

export function DangerZone(props: { websiteId: string; websiteName: string }) {
  const navigate = useNavigate();
  const [confirming, setConfirming] = createSignal(false);
  const [deleting, setDeleting] = createSignal(false);
  const [error, setError] = createSignal<string | null>(null);

  const removeWebsite = async () => {
    setDeleting(true);
    setError(null);
    try {
      await api.deleteWebsite(props.websiteId);
      await queryClient.invalidateQueries({ queryKey: ["websites"] });
      queryClient.removeQueries({ queryKey: ["overview", props.websiteId] });
      queryClient.removeQueries({
        queryKey: settingsQueryKey(props.websiteId),
      });
      navigate("/");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : String(cause));
      setDeleting(false);
    }
  };

  return (
    <section class="editor">
      <h2>Remove website</h2>
      <p>
        Removing this website hides it and all of its scan history everywhere.
        Recovery requires a manual database operation.
      </p>
      <Show
        when={confirming()}
        fallback={
          <button
            class="signal-scan-btn signal-scan-cancel"
            type="button"
            onClick={() => setConfirming(true)}
            disabled={!isAdmin()}
            title={
              isAdmin()
                ? "Remove this website"
                : "Sign in to remove this website"
            }
          >
            Remove website
          </button>
        }
      >
        <button
          class="signal-scan-btn signal-scan-cancel"
          type="button"
          onClick={removeWebsite}
          disabled={deleting()}
        >
          {deleting() ? "Removing..." : `Really remove ${props.websiteName}?`}
        </button>
        <button
          class="signal-scan-btn"
          type="button"
          onClick={() => setConfirming(false)}
          disabled={deleting()}
        >
          Cancel
        </button>
      </Show>
      <Show when={error()}>
        <span class="signal-scan-error" role="alert">
          {error()}
        </span>
      </Show>
    </section>
  );
}
